<script lang="ts">
	import type { Component } from 'svelte';
	import CustomIcon from 'virtual:icons/material-symbols/tune-rounded';
	import ClaudeIcon from 'virtual:icons/simple-icons/claude';
	import GoogleIcon from 'virtual:icons/simple-icons/google';
	import MetaIcon from 'virtual:icons/simple-icons/meta';
	import OAIIcon from 'virtual:icons/simple-icons/openai';
	import ZaiIcon from 'virtual:icons/simple-icons/zdotai';

	import DeepSeekIcon from './DeepSeekIcon.svelte';
	import HCompanyIcon from './HCompanyIcon.svelte';
	import MistralIcon from './MistralIcon.svelte';
	import QwenIcon from './QwenIcon.svelte';

	interface Props {
		model: string;
	}
	let { model }: Props = $props();

	const iconMap: [string, Component][] = [
		['eu.anthropic', ClaudeIcon],
		['claude', ClaudeIcon],
		['vertex.claude', ClaudeIcon],
		['gpt', OAIIcon],
		['o4', OAIIcon],
		['o3', OAIIcon],
		['azure', OAIIcon],
		['llama', MetaIcon],
		['mistral', MistralIcon],
		['magistral', MistralIcon],
		['qwen', QwenIcon],
		['holo', HCompanyIcon],
		['deepseek', DeepSeekIcon],
		['gemma', GoogleIcon],
		['glm', ZaiIcon]
	];

	function getIcon(modelString: string): Component {
		const lower = modelString.toLowerCase();
		return iconMap.find(([key]) => lower.startsWith(key))?.[1] ?? CustomIcon;
	}

	const IconComponent = $derived(getIcon(model));
</script>

{#if IconComponent}
	<IconComponent />
{/if}
